import { Navigate, Route, Routes } from 'react-router-dom'
import { ThreadProvider } from './api/sse/prepare-chat/thread-provider.tsx'
import PrepareChatPage from './app/prepare-chat/page'
import ProjectsGridView from './app/projects-grid/ProjectsGridView'
import Template from './app/template'
import UploadView from './app/upload-view/UploadView'
import { AccountPage } from './app/account/AccountPage'
import { AuthProvider, useAuth } from './auth/AuthProvider'
import { AuthChoice } from './auth/AuthChoice'
import { AppLayout } from './components/Layout/AppLayout'
import { Toaster } from './components/Toaster'
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute'
import { Unauthorized } from './components/Unauthorized/Unauthorized'

const fontClasses = 'bg-background text-foreground antialiased bg-white'

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        Loading...
      </div>
    )
  }

  // Not authenticated - show different content based on route
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route
          path='/'
          element={
            <AuthChoice onAuthenticated={() => window.location.reload()} />
          }
        />
        <Route
          path='/upload'
          element={
            <AuthChoice onAuthenticated={() => window.location.reload()} />
          }
        />
        <Route path='*' element={<Unauthorized />} />
      </Routes>
    )
  }

  // Authenticated - show full app with layout
  return (
    <ThreadProvider>
      <AppLayout>
        <div className={fontClasses}>
          <Routes>
            <Route path='/' element={<UploadView />} />
            <Route path='/upload' element={<UploadView />} />

            <Route
              path='/account'
              element={
                <Template>
                  <AccountPage />
                </Template>
              }
            />
            <Route
              path='/projects'
              element={
                <Template>
                  <ProjectsGridView />
                </Template>
              }
            />
            <Route
              path='/thread/:threadId/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route path='/thread/:threadId/upload' element={<UploadView />} />
            <Route
              path='/projects/:projectId/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route
              path='/projects/:projectId/files/:fileId/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route
              path='/projects/:projectId/files/:fileId/sheets/:sheetId/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route
              path='/projects/:projectId/artifacts/:artifactId/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route
              path='/projects/:projectId/upload'
              element={<UploadView />}
            />
            <Route
              path='/prepare-chat'
              element={
                <Template>
                  <PrepareChatPage />
                </Template>
              }
            />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
        </div>
        <Toaster />
      </AppLayout>
    </ThreadProvider>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App
